
import commonApi from "@/apis/common.api";
import { $_DKD } from "@/confs/common.const.js";
import gripUtil from "@/libs/grip.util.js"
import {$_TYPE} from "../confs/common.const";

export default {
    state: {
        newsTab: [
            {code: '2', name: '코로나19'},
            {code: '1', name: '정책브리핑'},
        ],
        selectedNewsTab: '2',
        briefingList: [],
        covidNewsList: [],
        videoNewsList: [],
        photoList: [],

        latestBriefing: {},
        latestCovidNews: {},
    },
    getters: {
        getNewsTab(state) {
            return state.newsTab;
        },
        getSelectedNewsTab(state) {
            return state.selectedNewsTab;
        },
        getBriefingList(state) {
            return state.briefingList;
        },
        getCovidNewsList(state) {
            return state.covidNewsList;
        },
        getVideoNewsList(state) {
            return state.videoNewsList;
        },
        getPhotoList(state) {
            return state.photoList;
        },
        getLatestBriefing(state) {
            return state.latestBriefing;
        },
        getLatestCovidNews(state) {
            return state.latestCovidNews;
        },
    },
    mutations: {
        SELECTED_NEWS_TAB(state, selectedNewsTab) {
            state.selectedNewsTab = selectedNewsTab;
        },
        BRIEFING_LIST(state, briefingList) {
            state.briefingList = briefingList;
        },
        COVID_NEWS_LIST(state, covidNewsList) {
            state.covidNewsList = covidNewsList;
        },
        VIDEO_NEWS_LIST(state, videoNewsList) {
            state.videoNewsList = videoNewsList;
        },
        PHOTO_LIST(state, photoList) {
            state.photoList = photoList;
        },
        LATEST_BRIEFING(state, latestBriefing) {
            state.latestBriefing = latestBriefing;
        },
        LATEST_COVID_NEWS(state, latestCovidNews) {
            state.latestCovidNews = latestCovidNews;
        },
    },
    actions : {
        SET_SELECTED_NEWS_TAB({commit}, selectedNewsTab) {
            commit("SELECTED_NEWS_TAB", selectedNewsTab);
        },
        FETCH_BRIEFING_LIST({commit}) {
            // let today = new Date();
            // let searchDay = new Date(today - (3600000 * 24 * 30));
            // let searchFromDate = searchDay.format('yyyyMMdd')+'0000';
            // let q = 'where=val4::N&orderBy=val1::desc&searchFromDate=' + searchFromDate;
            // if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
            //     q = "where=val4::N&orderBy=val1::desc&searchLimit=30";
            // }
            let q = 'where=val4::N&orderBy=val1::desc';
            return commonApi.fetchRepoDataList($_DKD.BRIEFING, q)
                .then((res)=>{
                    let list = res.data.data;
                    let returnList = [];

                    list.forEach((data)=>{
                        if(data.val10 !== '') {
                            returnList.push(data);
                        }
                    });
                    commit('BRIEFING_LIST', returnList);
                });
        },
        FETCH_COVID_NEWS_LIST({commit}) {
            let today = new Date();
            let searchDay = new Date(today - (3600000 * 24 * 60));
            let searchFromDate = searchDay.format('yyyyMMdd')+'0000';
            let q = 'where=val16::N&whereLike=val5::youtube&whereLike=val10::'+encodeURIComponent('코로나')+'&orderBy=val1::desc&searchFromDate=' + searchFromDate;

            let list = [];
            return commonApi.fetchRepoDataList($_DKD.GU_NEWS, q)
                .then((res)=>{
                    list = res.data.data
                    let map = gripUtil.toDict(list,'val1');
                    q = 'where=val16::N&whereLike=val5::youtube&whereLike=val10::'+encodeURIComponent('C19')+'&orderBy=val1::desc&searchFromDate=' + searchFromDate;
                    return commonApi.fetchRepoDataList($_DKD.GU_NEWS, q)
                        .then((res)=>{
                            res.data.data.forEach(d=>{
                                if(typeof map[d.val1] === $_TYPE.UNDEF){
                                    list.push(d);
                                }
                            });
                            list = list.filter((d) => {
                                return d.val10.indexOf("정책브리핑") < 0;
                            });
                            list.sort((p, c)=>{
                                return Number(c.val1) - Number(p.val1);
                            });
                            commit('COVID_NEWS_LIST', list);
                        });
                });
        },
        FETCH_VIDEO_NEWS_LIST({commit}) {
            let q = 'orderBy=val1::desc&searchLimit=30';
            return commonApi.fetchRepoDataList($_DKD.VIDEO_NEWS, q)
                .then((res)=>{
                    commit('VIDEO_NEWS_LIST', res.data.data);
                });
        },
        FETCH_PHOTO_LIST({commit}) {
            let q = 'where=val6::N&orderBy=basdtVal::desc&searchLimit=30';
            return commonApi.fetchRepoDataList($_DKD.TODAY_PHOTO, q)
                .then((res)=>{
                    commit('PHOTO_LIST', res.data.data);
                });
        },
        FETCH_LATEST_BRIEFING({commit}) {
            let q = "where=val4::N&orderBy=val1::desc&searchLimit=10";
            return commonApi.fetchRepoDataList($_DKD.BRIEFING, q)
                .then((res)=>{
                    let list = res.data.data;
                    let returnList = [];

                    list.forEach((data)=>{
                        if(data.val10 !== '') {
                            if(returnList.length < 8) {
                                returnList.push(data);
                            }
                        }
                    });
                    commit('LATEST_BRIEFING', returnList[0]);
                });
        },
        FETCH_LATEST_COVID_NEWS({commit}) {
            let q = 'where=val16::N&whereLike=val5::youtube&whereLike=val10::'+encodeURIComponent('C19 브리핑')+'&orderBy=val1::desc&searchLimit=10';
            return commonApi.fetchRepoDataList($_DKD.GU_NEWS, q)
                .then((res)=>{
                    commit('LATEST_COVID_NEWS', res.data.data[0]);
                });
        },
    }
};
